import script from "./UserInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInformation.vue?vue&type=script&setup=true&lang=js"

import "./UserInformation.vue?vue&type=style&index=0&id=d012c95e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d012c95e"]])

export default __exports__